import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface ReadAnalysisCriteria {
    analysisId: string;
}

class ReadAnalysisCriteriaImpl implements ReadAnalysisCriteria {
    constructor(readonly analysisId: string) {}
}

export class ReadAnalysisCriteriaBuilder {
    private analysisId: Option<string> = none;

    static create = (): ReadAnalysisCriteriaBuilder => new ReadAnalysisCriteriaBuilder();

    withAnalysisId = (analysisId: string): ReadAnalysisCriteriaBuilder => {
        this.analysisId = some(analysisId);
        return this;
    };

    build = (): ReadAnalysisCriteria => {
        if (isNone(this.analysisId)) {
            throw new ReferenceError('Undefined prop');
        }

        return new ReadAnalysisCriteriaImpl(this.analysisId.value);
    };
}
